import * as React from "react";
import { LobNavigationItemsProps } from "./typings";
import LobNavigationItem from "./LobNavigationItem";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";
import { FlexComponent } from "src/typings/flexFramework/FlexComponent";

const LobNavigationItems = (props: LobNavigationItemsProps) => {
  const keyHelper = new ItemKeyHelper("storefrontWizardNavigation");
  const { handleLobChange, isTabChecked, getLabel, getLobIcon, searchParams, lobs } = props;

  return (
    <>
      {lobs.map((flexComponent: FlexComponent, index) => (
        <LobNavigationItem
          key={keyHelper.next()}
          flexComponent={flexComponent}
          index={index}
          getLabel={getLabel}
          isTabChecked={isTabChecked}
          getLobIcon={getLobIcon}
          handleLobChange={handleLobChange}
          lobsLength={lobs.length}
          searchParams={searchParams}
        />
      ))}
    </>
  );
};

export default LobNavigationItems;
